module.exports = __webpack_public_path__ + "media/images/emoticons/newmoon-75e232b0c25df202a5feb128b384ea1d.gif";